export default __webpack_public_path__ + "static/media/icono.24c39b1a.png";